// Environment variables - same pattern as main B18 app
export const _ENV_VARIABLES = {
  NODE_ENV: import.meta.env.VITE_NODE_ENV,
  API_KEY: import.meta.env.VITE_API_KEY,
  AUTH_DOMAIN: import.meta.env.VITE_AUTH_DOMAIN,
  PROJECT_ID: import.meta.env.VITE_PROJECT_ID,
  STORAGE_BUCKET: import.meta.env.VITE_STORAGE_BUCKET,
  MESSAGING_SENDER_ID: import.meta.env.VITE_MESSAGING_SENDER_ID,
  APP_ID: import.meta.env.VITE_APP_ID,
  MEASUREMENT_ID: import.meta.env.VITE_MEASUREMENT_ID,
  BACKEND_URL_PROD: import.meta.env.VITE_BACKEND_URL_PROD,
  B18_APP_URL: import.meta.env.VITE_B18_APP_URL
}

// Firebase config object
export const fbConfig = {
  apiKey: _ENV_VARIABLES.API_KEY,
  authDomain: _ENV_VARIABLES.AUTH_DOMAIN,
  projectId: _ENV_VARIABLES.PROJECT_ID,
  storageBucket: _ENV_VARIABLES.STORAGE_BUCKET,
  messagingSenderId: _ENV_VARIABLES.MESSAGING_SENDER_ID,
  appId: _ENV_VARIABLES.APP_ID,
  measurementId: _ENV_VARIABLES.MEASUREMENT_ID
}

// Default values
export const defaultValues = {
  DEFAULT_TIMEZONE: 'America/New_York'
}
